import React from 'react';
import { Checkbox } from '@usepepper/sprout-kit-ui';
import { createStyles } from '@/contexts/theme-context';
import { PRICING_TABLE_LAYOUT } from '@/experiences/sales-portal/domain/pricing/constants';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface Props {
  disabled?: boolean;
  isAllSelected: boolean;
  isPartiallySelected: boolean;
  label: string;
  onToggleAll: () => void;
}

export const PricingSelectAllRow: React.FC<Props> = ({
  disabled,
  isAllSelected,
  isPartiallySelected,
  label,
  onToggleAll,
}) => {
  const [styles] = useStyles();

  return (
    <View style={styles.base} testID="pricing-select-all-row">
      <View style={styles.checkboxContainer}>
        <Checkbox
          checked={
            isPartiallySelected
              ? 'indeterminate'
              : isAllSelected || isPartiallySelected
          }
          disabled={disabled}
          onPress={onToggleAll}
          size="$sm"
          tabIndex={-1}
          testID={`pricing-select-all-checkbox${isPartiallySelected ? '-indeterminate' : ''}${isAllSelected ? '-checked' : ''}`}
        />
      </View>
      <View style={styles.label}>
        <Typography variant="heading-sm">{label}</Typography>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    alignItems: 'center',
    flexDirection: 'row',
    paddingVertical: theme.sk.spacing.spaceMedium,
  },
  checkboxContainer: {
    // Match the grid's checkbox column: right-align the checkbox inside a
    // fixed-width column so its right edge lands on the column boundary,
    // exactly like the data-row checkboxes.
    alignItems: 'flex-end',
    justifyContent: 'center',
    width: PRICING_TABLE_LAYOUT.CHECKBOX_COLUMN_WIDTH,
  },
  label: {
    paddingLeft: theme.sk.spacing.spaceSmall,
  },
}));
